import { mkNode } from '@p4b/utils';
import { Thumbnail, ThumbnailBase } from '@p4b/thumbnail-base';
import { Img } from '@p4b/image-base';
import { rendererFromImage } from '@p4b/image-base';
import { ImageViewerElement } from '@p4b/image-viewer';


export class ResourceThumbnail extends ThumbnailBase implements Thumbnail {
    private thumb: HTMLCanvasElement;
    private cols: number;
    private rows: number;
    private imageData?: ImageData;

    public constructor(image: Img, frag: Node, releaseButton = false) {
        const {rows, cols} = image;
        const thumbCols = (cols != undefined && rows != undefined) ? Math.floor(120 * cols / rows) : 120;
        const thumbRows = 120;
        let thumb;
        super(frag, image, releaseButton, (figure: HTMLDivElement) => {
            thumb = mkNode('canvas', {
                className: 'thumbnail',
                parent: figure,
                style: {visibility: 'hidden', width: thumbCols + 'px', height: thumbRows + 'px'},
                attrib: {title: 'Click on the thumbnail to view and manipulate the image.', draggable: 'false'},
            });
        });
        this.cols = thumbCols;
        this.rows = thumbRows;
        if (!thumb) {
            throw "Thumbnail canvas is null.";
        }
        this.thumb = thumb;
        this.thumb.addEventListener('contextrestored', this.handleContextRestored);
    }

    public async load(thumbnail: ArrayBuffer|null): Promise<void> {
        if (thumbnail) {
            try {
                const cxt = this.thumb.getContext('2d');
                if (cxt != null) {
                    this.thumb.width = 120;
                    this.thumb.height = 120;
                    if (thumbnail) {
                        const uint8clamped = new Uint8ClampedArray(thumbnail);
                        this.thumb.width = uint8clamped.length / 480;
                        this.imageData = new ImageData(uint8clamped, this.thumb.width, this.thumb.height);
                        cxt.putImageData(this.imageData, 0, 0);
                    }
                    this.thumb.style.visibility = 'visible';
                }
            } catch (e) {
                console.error('THUMBNAIL LOAD ERROR', e);
            }
        }
    }

    private readonly handleContextRestored = () => {
        if (this.imageData) {
            const cxt = this.thumb.getContext('2d');
            if (cxt != null) {
                cxt.putImageData(this.imageData, 0, 0);
            }
        }
    }

    public open(viewer: ImageViewerElement) {
        viewer.setRenderer(rendererFromImage(this.image));
    }

    public async defferedLoad(viewer: ImageViewerElement): Promise<void> {
        await viewer.load();
    }

    public destroy(): void {
        super.destroy();
        this.thumb.removeEventListener('contextrestored', this.handleContextRestored);
        //console.debug('thumbnail: destroy');
    }
}
